import React from "react";
import { Menu, MenuItem, Typography, CircularProgress } from "@mui/material";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";

interface ModelSelectionMenuProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  models: {
    [key: string]: { name: string; model: string; description: string };
  };
  selectedModel: string;
  onModelSelect: (model: string) => void;
  isLoadingModel: boolean;
}

const ModelSelectionMenu: React.FC<ModelSelectionMenuProps> = ({
  anchorEl,
  open,
  onClose,
  models,
  selectedModel,
  onModelSelect,
  isLoadingModel,
}) => {
  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      autoFocus={false}
      slotProps={{
        paper: {
          sx: {
            backdropFilter: 'blur(20px)',
            background: 'rgba(255,255,255,0.7)',
            borderRadius: '12px',
            border: '1px solid rgba(255,255,255,0.3)',
          },
        },
      }}
    >
      {Object.entries(models).map(([key, model]) => (
        <MenuItem
          key={key}
          onClick={() => onModelSelect(key)}
          disabled={isLoadingModel}
        >
          <CheckOutlinedIcon
            sx={{
              mr: 1,
              fontSize: 16,
              color: "primary.main",
              visibility: selectedModel === key ? "visible" : "hidden",
            }}
          />
          <Typography variant="body2" sx={{ mr: 1 }}>
            {model.name}
          </Typography>
          <Typography
            variant="body2"
            color="textSecondary"
            sx={{
              fontSize: "0.75rem",
              ml: 0.5,
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {model.description}
          </Typography>
        </MenuItem>
      ))}
    </Menu>
  );
};

export default ModelSelectionMenu;
